import React, {Component} from 'react';
import axios from 'axios';
import InsuranceItem from './misc/InsuranceItem';
import {phoneNumberMask, states, dateMask } from '../utilities';
import moment from 'moment';

import Loader from '../elements/Loader'

class RegisterCovid extends Component {
  constructor(props){
    super(props);
    this.state = {
      lastName: '',
      firstName: '',
      dob: '',
      gender: '',
      address: '',
      city: '',
      state: '',
      zip: '',
      email: '',
      phone: '',
      isInsurance: '',
      insurance: '',
      insuranceID: '',
      policy: '',
      submitted: false,
      policy: '',      
      errors: [],
      loading: false,
      error: '',

      otherInsuranceInfo: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: ''
      },
      relationToInsured: '',
      guarantor: {
        lastName: '',
        firstName: '',
        dob: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
      },
    }
  }

  handleChange = (key, value, e) => {
    this.setState({[key]: value})
  }

  onChangeOtherInsurance = (key, value, e) => {
    if(key === 'phone'){
      value = phoneNumberMask(value)
    } else {
      value = value.toUpperCase();
    }
    let newInsurance = {...this.state.otherInsuranceInfo};
    newInsurance[key] = value;
    this.setState({otherInsuranceInfo: newInsurance, insurance: value})
  }

  onChangeGuarantor = (key, value, e) => {
    if(key === 'dob'){
      value = dateMask(value)
    } else if(key === 'phone'){
      value = phoneNumberMask(value)
    } else {
      value = value.toUpperCase();
    }
    let newGuarantor = {...this.state.guarantor};
    newGuarantor[key] = value;
    this.setState({guarantor: newGuarantor})
  }

  onChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if(name === 'phone'){
      value = phoneNumberMask(value)
    }
    if(name === 'dob'){
      value = dateMask(value)
    }
    this.setState({
      [name]: value
    })
  }

  register = () => {
    this.setState({
      loading: true
    })
    let formData = {};
    formData.clientID = this.props.match.params.id;

    let errors = [];
    if (this.state.lastName){
      formData.lastName = this.state.lastName;
    } else {
      errors.push("Last Name is required")
    }

    if (this.state.firstName){
      formData.firstName = this.state.firstName;
    } else {
      errors.push("First Name is required")
    }

    if (this.state.dob && moment(this.state.dob, 'MM/DD/YYYY').isValid()){
      formData.dob = this.state.dob;
    } else {
      errors.push("Please enter a valid DOB")
    }

    if (this.state.gender){
      formData.gender = this.state.gender;
    } else {
      errors.push("Gender is required")
    }

    if (this.state.address){
      formData.address = this.state.address;
    } else {
      errors.push("Address is required")
    }

    if (this.state.city){
      formData.city = this.state.city;
    } else {
      errors.push("City is required")
    }

    if (this.state.state){
      formData.state = this.state.state;
    } else {
      errors.push("State is required")
    }

    if (this.state.zip){
      formData.zip = this.state.zip;
    } else {
      errors.push("Zip is required")
    }

    if (this.state.email){
      formData.email = this.state.email;      
    } else {
      if (this.state.phone){
        formData.email = "";
      } else {
        errors.push("Email or Phone is required")
      }      
    }

    if (this.state.phone){
      formData.phone = this.state.phone;
    } else {
      if (this.state.email){
        formData.phone = "";
      }  
    } 
    
    if (this.state.isInsurance){
      if (this.state.isInsurance === '1'){
        if (this.state.policy){
          formData.policy = this.state.policy;
        } else {
          errors.push("Policy is required")
        }
        if (this.state.insurance){
          formData.insurance = this.state.insurance;
        } else {
          errors.push("Insurance Name is required")
        }
        if (this.state.relationToInsured){
          formData.relationToInsured = this.state.relationToInsured;
          if (this.state.relationToInsured === 'Self'){
            formData.guarantor = {
              lastName: this.state.lastName,
              firstName: this.state.firstName,
              dob: this.state.dob,
              address: this.state.address,
              city: this.state.city,
              state: this.state.state,
              zip: this.state.zip,
              phone: this.state.phone,
            }
          } else {
            if (this.state.guarantor.lastName){
              formData.guarantor.lastName = this.state.guarantor.lastName;
            } else {
              errors.push("Guarantor Last Name is required")
            }
        
            if (this.state.guarantor.firstName){
              formData.guarantor.firstName = this.state.guarantor.firstName;
            } else {
              errors.push("Guarantor First Name is required")
            }
        
            if (this.state.guarantor.dob){
              formData.guarantor.dob = this.state.guarantor.dob;
            } else {
              errors.push("Guarantor Date of Birth is required")
            }
        
            if (this.state.guarantor.address){
              formData.guarantor.address = this.state.guarantor.address;
            } else {
              errors.push("Guarantor Address is required")
            }
        
            if (this.state.guarantor.city){
              formData.guarantor.city = this.state.guarantor.city;
            } else {
              errors.push("Guarantor City is required")
            }
        
            if (this.state.guarantor.state){
              formData.guarantor.state = this.state.guarantor.state;
            } else {
              errors.push("Guarantor State is required")
            }
        
            if (this.state.guarantor.zip){
              formData.guarantor.zip = this.state.guarantor.zip;
            } else {
              errors.push("Guarantor Zip is required")
            }
        
            if (this.state.guarantor.phone){
              formData.guarantor.phone = this.state.guarantor.phone;
            } else {
              errors.push("Guarantor Phone is required")
            }
          }
        } else {
          errors.push("Relation to insured is required")
        }
        formData.insuranceID = this.state.insuranceID;
        formData.otherInsuranceInfo = this.state.otherInsuranceInfo;
      }      
    } else {
      errors.push("Are You Insured?")
    }

    if (errors.length){
      this.setState({
        errors: errors,
        loading: false,
      })
    } else {
      axios({
        method: 'POST',
        url: `${process.env.REACT_APP_URL}/covid-registration`,
        data: formData,
      }).then(res => {
        console.log(res)
        if (res.data.err){
          this.setState({
            error: res.data.err,
            lastName: '',
            firstName: '',
            dob: '',
            gender: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            errors: [],
            loading: false,
          })
        } else {
          this.setState({
            submitted: true,
            lastName: '',
            firstName: '',
            dob: '',
            gender: '',
            address: '',
            city: '',
            state: '',
            zip: '',
            email: '',
            phone: '',
            errors: [],
            loading: false,
          })
        }        
      }).catch(err => {
        console.log(err)
      })
    }
  }

  back = () => {
    this.setState({
      submitted: false,
      error: '',
    })
  }

  consent = () => {
    window.open(`${process.env.REACT_APP_URL_API || ''}/v0/consent`)
  }

  renderForm(){
    return(
      <div>
        <h3>Welcome to Empire City Laboratories</h3>
        <form className="form m-t" role="form">
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your First Name' 
              required='required'
              name="firstName" 
              value={this.state.firstName} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your Last Name' 
              required='required'
              name="lastName" 
              value={this.state.lastName} 
              onChange={this.onChange}/>
          </div>              
          <div className="form-group">
            <label>Date of Birth</label>
            <input className="form-control input-sm" 
              type='text' 
              placeholder='MM/DD/YYYY' 
              required='required'
              name="dob" 
              value={this.state.dob} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="gender" value={this.state.gender} onChange={this.onChange}>
              <option value="">Select Gender</option>
              <option value="F">Female</option>
              <option value="M">Male</option>
              <option value="U">Prefer not to answer</option>
            </select>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your Address' 
              required='required'
              name="address" 
              value={this.state.address} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your City' 
              required='required'
              name="city" 
              value={this.state.city} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <select className="form-control input-sm" name="state" value={this.state.state} onChange={this.onChange}>
              <option value="">Select State</option>
              {states.map(item => 
                <option key={item.abbreviation} value={item.abbreviation}>{item.name}</option>
              )}
            </select>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
            type='text' 
            placeholder='Enter Your Zip' 
            required='required'
            name="zip" 
            value={this.state.zip} 
            onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
              type='text' 
              placeholder='Enter Your Email' 
              required='required' 
              name="email" 
              value={this.state.email} 
              onChange={this.onChange}/>
          </div>
          <div className="form-group">
            <input className="form-control input-sm" 
            type='text' 
            placeholder='Enter Your Phone' 
            required='required' 
            name="phone" 
            value={this.state.phone} 
            onChange={this.onChange}/>
          </div> 
          <div className="form-group">
            <select className="form-control input-sm" name="isInsurance" value={this.state.isInsurance} onChange={this.onChange}>
              <option value="">Do you have an insurance?</option>
              <option value="0">No</option>
              <option value="1">Yes</option>
            </select>
          </div>
          {this.state.isInsurance && this.state.isInsurance !== '0' ? 
            <InsuranceItem 
              name={this.state.insurance} 
              id={this.state.insuranceID} 
              policy={this.state.policy} 
              relationToInsured={this.state.relationToInsured}
              guarantor={this.state.guarantor}
              onChangeGuarantor={this.onChangeGuarantor}
              onSelectInsurance={this.onSelectInsurance} 
              otherInsuranceInfo={this.state.otherInsuranceInfo}
              onChangeOtherInsurance={this.onChangeOtherInsurance}
              onChange={this.handleChange}
            /> : null
          }           
        </form>
        {this.state.errors ? 
          <ul style={{color: 'red', fontWeight: 'bold', listStyle: 'none', textAlign: 'left'}}>
            {this.state.errors.map((item, index) => <li key={index}>{item}</li>)}
          </ul> : null
        }
        <button className="btn block btn-primary full-width m-b" onClick={this.register}>{this.state.loading ? <Loader/> : 'Register'}</button>
        <p className="m-t"><small>&copy; 2008-2021 Empire City Laboratories, Inc. All Rights Reserved. ECL and Empire City Laboratories are registered trademarks of Empire City Laboratories®, Inc.</small></p>
      </div> 
    )
  }

  render(){
    if (this.state.submitted){
      return (
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h1 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>Thank you for registering!</h1>
            <br/>
            <i className="fa fa-thumbs-up modal-icon modal-icon-warning" style={{fontSize: '100pt'}}></i>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.back}>Back</button>
          </div>
        </div>
      )
    } else if(this.state.error){
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          <div style={{textAlign: 'center'}}>
            <h1 className="font-bold" style={{fontSize: '18pt', lineHeight: '30px'}}>{this.state.error}</h1>
            <br/>
            <i className="fa fa-warning modal-icon modal-icon-danger" style={{fontSize: '100pt'}}></i>
            <br/><br/>
            <button className="btn btn-primary" onClick={this.back}>Back</button>
          </div>
        </div>
      )      
    } else {
      return(
        <div className="middle-box text-center loginscreen animated fadeInDown">
          {this.renderForm()}
        </div>
      )
    }    
  }
}
export default RegisterCovid